import { render, staticRenderFns } from "./ProfileSettingForm.vue?vue&type=template&id=13021a34&"
import script from "./ProfileSettingForm.vue?vue&type=script&lang=js&"
export * from "./ProfileSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports